import clsx from 'clsx';
import React from 'react';

interface ColorsProps {
  selectedColor: string;
  setSelectedColor: (color: string) => void;
  colors: string[];
  error?: string;
}

export const Colors = ({
  selectedColor,
  setSelectedColor,
  colors,
  error,
}: ColorsProps) => {
  return (
    <>
      <div className="mt-2 flex gap-2">
        {colors.map((color) => (
          <ColorEllipsis
            key={color}
            color={color}
            selected={selectedColor === color}
            onClick={() => setSelectedColor(color)}
          />
        ))}
      </div>
      {error && (
        <p className="mt-1 text-xs text-input-content-error">{error}</p>
      )}
    </>
  );
};

interface ColorEllipsisProps {
  color: string;
  selected?: boolean;
  onClick?: () => void;
}

const ColorEllipsis = ({ color, selected, onClick }: ColorEllipsisProps) => {
  return (
    <div
      className={clsx(
        'flex h-8 w-8 items-center justify-center rounded-full',
        selected && 'border border-input-background-selected',
      )}
      onClick={onClick}
    >
      <div
        className="h-6 w-6 cursor-pointer rounded-full"
        style={{ backgroundColor: color }}
      />
    </div>
  );
};

export default Colors;
